import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Legend } from '../../../../common/chart/legend'
import { PieChartContainer } from '../../../../common/chart/pieChart'
import { Element } from '../../../../common/html/element'
import { getUnique } from '../../../../helpers/common'
import { formatVal } from '../../../../helpers/value'
import { selectOwnershipAndGroup } from '../../store/slice'
import { DATA_KEYS } from './helper'

const COLORS = [
  '#006AA6',
  '#FFCD60',
  '#D96383',
  '#74B49A',
  '#F49966',
  '#00A8B5',
]

export const Chart = () => {
  const locale = useSelector((state) => state.i18n.locale)
  const chartId = useRef(getUnique())

  const data = useSelector(
    selectOwnershipAndGroup((data) => data[DATA_KEYS.OWNERSHIP_TYPES] || []),
  ).slice(0, 6)

  const dataChart = data.map((item, index) => ({
    name: item.ownerShipTypeName || '',
    value: Math.min(item.percentage, 1),
    color: COLORS[index],
  }))

  const legendItems = data.map((item, index) => ({
    title: item.ownerShipTypeName || '',
    value: item.percentage,
    color: COLORS[index],
    pieIndex: index,
    isEllipsis: true,
    lineClamp: 3,
  }))

  return (
    <Element className="flexColumn flex1 minW0">
      <Element className="fw600" style={{ color: '#3A414B' }}>
        <Translate value="companySummary.ownershipGroup.OWNERSHIP_TYPES" />
      </Element>
      <Element className="flex1 minH0 dFlex alignItemsCenter justifyContentBetween positionRelative">
        <Element style={{ marginLeft: -4, marginRight: 10 }}>
          <PieChartContainer
            chartId={chartId.current}
            data={dataChart}
            width={160}
            height={160}
            innerRadius={35}
            isLabelActive={false}
            formatValueTooltip={(value) => formatVal(value * 100, locale) + '%'}
          />
        </Element>
        <Element className="flex1 minW0">
          <Legend
            chartId={chartId.current}
            items={legendItems}
            className="flexColumn"
          />
        </Element>
      </Element>
    </Element>
  )
}
